import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import {
  tesaChipBlue,
  tesaChipBlueGrey,
  tesaChipDarkblue,
  tesaChipGreen,
  tesaChipGrey,
  tesaChipLightblue,
  tesaChipOrange,
  tesaChipPurple,
  tesaChipRed,
  tesaChipTurquoise,
  tesaChipYellow,
  tesaDarkGrey,
  tesaPurple,
  tesaWhite,
} from "../../styles/colors";
import TestRequestStatus from "../../api/models/test-request/TestRequestStatusResponse";

type TestRequestState = TestRequestRaw.Schemas.TestRequestState;
export type TestRequestDisplayedState = Exclude<TestRequestState, "DELETED" | "__NONE">;
export type TestRequestDisplayedStateStatus = Omit<TestRequestStatus, "state"> & { state: TestRequestDisplayedState };

const COLORS_BY_STATE: {
  [State in TestRequestDisplayedState]: { background: string; color?: string };
} = {
  CANCELED: { background: tesaChipPurple },
  COMPLETED: { background: tesaChipGreen },
  DECLINED: { background: tesaChipRed },
  DRAFT: { background: tesaChipOrange },
  FOR_APPROVAL: { background: tesaChipBlueGrey },
  FOR_EVALUATION: { background: tesaChipLightblue, color: tesaDarkGrey },
  FOR_REVIEW: { background: tesaChipDarkblue },
  IN_EXECUTION: { background: tesaChipBlue },
  IN_PREPARATION: { background: tesaChipYellow, color: tesaDarkGrey },
  REPORT_CREATION: { background: tesaChipGrey, color: tesaDarkGrey },
  SUBMITTED: { background: tesaChipTurquoise },
};

const useStyles = makeStyles({
  span: {
    backgroundColor: ({ status }: StatusChipProps) => COLORS_BY_STATE[status.state]?.background || tesaPurple,
    borderRadius: "18px",
    color: ({ status }: StatusChipProps) => COLORS_BY_STATE[status.state]?.color || tesaWhite,
    display: "inline-block",
    fontFamily: "Proxima Nova",
    fontSize: "0.75rem",
    letterSpacing: "0.4px",
    lineHeight: "0.75rem",
    padding: "6px 8px",
  },
});

interface StatusChipProps {
  className?: string;
  status: TestRequestDisplayedStateStatus;
}

const StatusChip = (props: StatusChipProps) => {
  const classes = useStyles(props);
  const { className, status } = props;

  return (
    <div className={className}>
      <span className={classes.span}>{status.label}</span>
    </div>
  );
};

export default StatusChip;
